"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const CampaignIcon = ({ status, type }) => {
    const fill = status === 'DRAFT' ? src_1.titanium : src_1.steel;
    let icon;
    switch (type) {
        case 'CampaignScheduledTrigger':
            icon = React.createElement(src_1.CalendarIcon, { fill: fill, height: "20", width: "20", viewBox: "0 0 24 24" });
            break;
        case 'CampaignAutomatedTrigger':
            icon = React.createElement(src_1.ZapIcon, { fill: fill, height: "20", width: "20", viewBox: "0 0 24 24" });
            break;
        case 'CampaignAPITrigger':
            icon = React.createElement(src_1.HashtagIcon, { fill: fill, height: "24", width: "24", viewBox: "0 0 20 20" });
            break;
        case 'URLCampaignTrigger':
        default:
    }
    return (React.createElement("div", { style: {
            height: 40,
            width: 40,
            borderRadius: 40,
            border: status === 'DRAFT' ? `2px dashed ${src_1.titanium}` : 'none',
            background: status === 'DRAFT' ? undefined : src_1.cloud,
            marginRight: 16,
            flex: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } }, icon));
};
exports.default = CampaignIcon;
